import { Link } from "react-router-dom";

/**
 * DemoEntry (Scope A2) — the demo's front door. No login; one click drops the
 * prospect into the pre-populated workspace. Kept dependency-free (no synced
 * leaves) so it also serves as the toolchain smoke screen: if tokens + fonts
 * render here, the Vite/Tailwind/self-hosted-font pipeline is sound.
 */
export function DemoEntry() {
  return (
    <main className="mx-auto flex min-h-[calc(100dvh-2rem)] max-w-3xl flex-col items-center justify-center px-6 text-center">
      <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[var(--color-gold-soft)]">
        Psy180 · interactive demo
      </p>
      <h1 className="mt-4 font-heading text-4xl font-medium leading-tight text-[var(--color-text-primary)] sm:text-5xl">
        Try the whole platform —{" "}
        <em className="font-normal italic text-[var(--color-gold-soft)]">no account, nothing saved.</em>
      </h1>
      <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-[var(--color-text-muted)]">
        Click through a real therapist&apos;s workspace: add a client, run a live
        bilateral-stimulation session, feel the audio and controller haptics, and
        see exactly what your client sees. Everything here is sample data and
        resets the moment you refresh.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 rounded-lg bg-[var(--color-gold)] px-6 py-3 font-mono text-[12px] uppercase tracking-wide text-[var(--color-bg-deep)] transition-colors hover:bg-[var(--color-gold-soft)]"
        >
          Enter the demo workspace →
        </Link>
        <Link
          to="/session"
          className="inline-flex items-center gap-2 rounded-lg border border-[var(--color-border-strong)] bg-[var(--color-navy-mid)] px-6 py-3 font-mono text-[12px] uppercase tracking-wide text-[var(--color-text-primary)] transition-colors hover:border-[var(--color-gold)] hover:text-[var(--color-gold-soft)]"
        >
          Jump straight to a session
        </Link>
      </div>
      <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--color-text-ghost)]">
        Audio needs a tap to start · haptics need a game controller · camera stays on your device
      </p>
    </main>
  );
}
